import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import PaymentForm from './PaymentForm';

// Cache for stripe instances to avoid reloading
const stripeCache = {};

const Payment = ({ clientSecret, redirectUrl, stripeKey }) => {
  // Use branch-specific key or fallback to env variable
  const publishableKey = stripeKey || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  // Memoize stripe promise to prevent reloading on every render
  const stripePromise = useMemo(() => {
    if (!publishableKey) return null;

    // Return cached instance if available
    if (stripeCache[publishableKey]) {
      return stripeCache[publishableKey];
    }

    // Load and cache new instance
    const promise = loadStripe(publishableKey);
    stripeCache[publishableKey] = promise;
    return promise;
  }, [publishableKey]);

  if (!stripePromise) {
    return <div className="text-danger">Stripe is not configured for this branch</div>;
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: { theme: 'flat' },
        clientSecret
      }}
    >
      <PaymentForm redirectUrl={redirectUrl} />
    </Elements>
  );
};

Payment.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  stripeKey: PropTypes.string // Optional - falls back to env variable
};

export default Payment;
